import { getApplicationDomain } from '../constants/apiEnvironments';
export const getLocationOrigin = hublet => {
  return `${window.location.protocol}//${getApplicationDomain(hublet)}`;
};